<template>
  <div class="card modal-card-panier modal-card-border">
    <div class="card-content">
      <div class="subtitle is-4 has-text-centered">Sélectionner un client</div>
      <section>
        <b-autocomplete
          v-model="nomClient"
          placeholder="Recherche"
          :keep-first="keepFirst"
          :open-on-focus="openOnFocus"
          :data="dataClients"
          field="libelleRecherche"
          @select="selectClient"
          @input="getAsyncClientData"
          :loading="isFetching" >
          <template slot="empty">Aucun résultat trouvé, saisir au moins 3 caractères</template>
          <template slot-scope="props">
            <div class="media-content">
              {{ props.option.libelleRecherche }}
              <br>
              <small>
                {{ props.option.adresse }}
              </small>
            </div>
          </template>
        </b-autocomplete>
      </section>
      <div class="has-text-centered couleurFontDefault"><span>ou</span></div>
      <div class="subtitle is-4 has-text-centered">Saisir un prospect</div>
      <section>
        <b-input type="text" v-model="nomProspect" placeholder="Saisir"></b-input>
        <b-field label="Siren">
          <b-input type="text" v-model="sirenProspect"></b-input>
        </b-field>
        <b-field v-if="isAffixe2" label="Application Tva" class=" mt-10">
          <b-select v-model="applicationTvaSelected" expanded>
            <option
              v-for="value in listeApplicationTva"
              :value="value.code"
              :key="value.code">
              {{ value.libelle }}
            </option>
          </b-select>
        </b-field>
        <adresse :adresse="adresseProspect"></adresse>
      </section>
      <br>
      <div v-if="nomProspect">
        <div class="columns" v-if="nomProspect">
          <div class="column">
            <p class="subtitle is-5 has-text-text">{{nomProspect}}</p>
            <div v-if="contactPanier">
              <div class="has-text-text">
                {{contactPanier.nom}} {{contactPanier.prenom}}
              </div>
              <div class="has-text-text" v-if="contactPanier.telephone">Téléphone :
                <strong>{{contactPanier.telephone}}</strong>
              </div>
              <div class="has-text-text" v-if="contactPanier.email">Email :
                <strong class="has-text-text">{{contactPanier.email}}</strong>
              </div>
              <a @click="contactPanier = null">
                <div class="has-text-danger is-size-7">
                  Supprimer un contact
                </div>
              </a>
            </div>
          </div>
        </div>
        <div v-if="!contactPanier">
          <div>
            <app-ajout-contact/>
          </div>
        </div>
      </div>
      <footer>
        <div class="columns">
          <div class="column">
            <button class="button is-gris button-modal"
                    @click="annuler()">
              Annuler
            </button>
          </div>
          <div class="column">
            <button class="button is-primary button-modal"
                    @click="addClient()">
              Valider
            </button>
          </div>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import * as typesPanier from '@/store/creationOpportunite/panier-mutation-type';
import * as typesClient from '@/store/modules/client-mutation-type';
import gestionErreur from '@/services/general/gestionErreur';
import debounce from 'lodash/debounce';
import { browseClientsByQuery } from '@/api/clients/index';
import { DEBOUNCE } from '@/configuration/autocompleteConf';
import { LISTE_APPLICATION_TVA, APPLICATION_TVA_TYPE_NORMAL } from '@/configuration/applicationTvaConf';
import * as clientConfig from '@/configuration/clientConf';
import genererAdresse from '@/services/general/genererAdresse';
import adresse from '@/components/general/adresse';
import toastConfirmation from '@/services/general/toastConfirmation';
import verifierAdresse from '@/services/client/verifierAdresse';
import ajoutContact from './ajoutContact';

const Panier = createNamespacedHelpers('panier');
const Client = createNamespacedHelpers('client');
const Parametrages = createNamespacedHelpers('parametrage');

export default {
  name: 'ajout-client',
  components: {
    appAjoutContact: ajoutContact,
    adresse,
  },
  data() {
    return {
      dataClients: [],
      isFetching: false,
      keepFirst: false,
      openOnFocus: false,
      data: [],
      nomClient: '',
      clientSelect: null,
      nomProspect: '',
      sirenProspect: '',
      adresseProspect: genererAdresse(),
      errorAddrese: false,
      applicationTvaSelected: APPLICATION_TVA_TYPE_NORMAL,
      listeApplicationTva: LISTE_APPLICATION_TVA,
    };
  },
  computed: {
    ...Panier.mapGetters({
      getClientPanier: 'clientPanier',
      getContactPanier: 'contactPanier',
    }),
    ...Client.mapGetters({
      getClient: 'client',
    }),
    ...Parametrages.mapGetters({
      isAffixe2: 'affixe2',
    }),
    clientPanier: {
      get() {
        return this.getClientPanier;
      },
      set(value) {
        this.setClientPanier(value);
      },
    },
    client: {
      get() {
        return this.getClient;
      },
      set(value) {
        this.setClient(value);
      },
    },
    contactPanier: {
      get() {
        return this.getContactPanier;
      },
      set(value) {
        this.setContactPanier(value);
      },
    },
  },
  methods: {
    ...Panier.mapMutations({
      setClientPanier: typesPanier.SET_CLIENT_PANIER,
      setContactPanier: typesPanier.SET_CONTACT_PANIER,
    }),
    ...Client.mapMutations({
      setClient: typesClient.SET_CLIENT,
    }),
    ...Client.mapActions({
      actionsRechercheDetailClient: 'rechercheDetailClient',
    }),
    /* eslint-disable-next-line */
    getAsyncClientData: debounce(function () {
      this.dataClients = [];
      if (this.nomClient.length <= 2) return;
      this.isFetching = true;
      browseClientsByQuery(this.nomClient, clientConfig.TYPE_CLIENT,
        clientConfig.SOUS_TYPE).then((response) => {
        response.data.forEach((client) => {
          this.dataClients.push(client);
        });
        this.isFetching = false;
      }).catch(() => {
        this.isFetching = false;
      });
    }, DEBOUNCE),
    selectClient(option) {
      this.clientSelect = option;
      if (this.clientSelect) {
        this.contactPanier = null;
        this.num = this.clientSelect.num;
        const loadingComponent = this.$buefy.loading.open({ container: null });
        this.actionsRechercheDetailClient({ cliNum: this.num }).then(() => {
          loadingComponent.close();
        });
      }
    },
    prospectSaisie() {
      if (Object.keys(this.adresseProspect).length > 0) {
        this.errorAddrese = verifierAdresse(this.adresseProspect);
      }
      this.clientSelect = {
        nomCommercial: this.nomProspect,
        adresse: this.adresseProspect,
        applicationTva: this.applicationTvaSelected,
        siren: this.sirenProspect,
      };
      this.client = this.clientSelect;
    },
    addClient() {
      if (this.nomProspect) this.prospectSaisie();
      if (this.client && this.client.nomCommercial) {
        if (this.errorAddrese) {
          toastConfirmation('Si un champ de l\'adresse est saisi, l\'intitulé 1 et la ville doivent l\'être aussi.', 'is-danger');
        } else {
          this.errorAddrese = false;
          this.clientPanier = this.client;
          this.$parent.close();
        }
      } else {
        gestionErreur('Aucun client sélectionné');
      }
    },
    annuler() {
      this.sirenProspect = '';
      this.contactPanier = null;
      this.clientSelect = null;
      this.client = null;
      this.$parent.close();
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/creationOpportunite/panier/client/ajoutClient.vue